import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LanguageSwitcher } from './shared/language-switcher/language-switcher';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LanguageSwitcher, NzIconModule],
  templateUrl: './app.component.html',
  standalone: true,
  styleUrl: './app.component.css'
})
export class AppComponent {
  private readonly title = inject(Title);
  private readonly translate = inject(TranslateService);

  readonly langOpen = signal(false);

  constructor() {
    this.translate.stream('common.appTitle').subscribe(value => this.title.setTitle(value));
  }
}
